import { Component, Input, OnInit, ViewChild, TemplateRef, ViewContainerRef, DoCheck } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  @Input() color="primary";
  @Input() diameter?: number = 50;
  @Input() mode?: ProgressSpinnerMode='indeterminate';
  @Input() strokeWidth?: number;
  @Input() value?: number=30;

  constructor() { }

  ngOnInit(): void {
  }

}
